import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getCheckoutPlatform, isNativeApp } from '../native-bridge';

const AppRedirect = ({ route, onNavigate }) => {
  const { t } = useTranslation();
  const [deeplink, setDeeplink] = useState('');

  useEffect(() => {
    const queryString = route.split('?')[1] || '';
    const params = new URLSearchParams(queryString);
    const target = params.get('target') || 'home';
    const sessionId = params.get('session_id');
    const boardId = params.get('id');

    // For web users (not native app), redirect directly to the appropriate page
    if (!isNativeApp()) {
      const platform = getCheckoutPlatform();
      if (target === 'success' && sessionId) {
        const successRoute = platform === 'mobile-web' ? 'success-mobile' : 'success-web';
        onNavigate(`/${successRoute}?session_id=${encodeURIComponent(sessionId)}`);
      } else if (target === 'board' && boardId) {
        onNavigate(`/board/${boardId}`);
      } else {
        onNavigate('/');
      }
      return;
    }

    // For native app users, attempt to open the app via deep link
    let nextLink = 'mymanifest://home';
    if (target === 'success') {
      nextLink = sessionId
        ? `mymanifest://success?session_id=${encodeURIComponent(sessionId)}`
        : 'mymanifest://success';
    } else if (target === 'board') {
      nextLink = boardId
        ? `mymanifest://board?id=${encodeURIComponent(boardId)}`
        : 'mymanifest://home';
    }

    setDeeplink(nextLink);
    window.location.href = nextLink;
  }, [route, onNavigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <Loader2 className="w-16 h-16 animate-spin text-purple-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">{t('appRedirect.returning')}</h2>
        <p className="text-gray-600 mb-6">
          {t('appRedirect.autoOpenHint')}
        </p>
        {deeplink && (
          <a
            href={deeplink}
            className="w-full px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition font-medium inline-flex items-center justify-center mb-3"
          >
            {t('appRedirect.openApp')}
          </a>
        )}
        <button
          onClick={() => onNavigate('/')}
          className="w-full text-sm text-gray-500 hover:text-gray-700"
        >
          {t('appRedirect.continueOnWeb')}
        </button>
      </div>
    </div>
  );
};

export default AppRedirect;
